var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"text-center"},[_vm._v("Accés non autorisé")]),_c('p',[_vm._v(_vm._s(_vm.getError))])])
}
var staticRenderFns = []

export { render, staticRenderFns }